module.exports = __webpack_public_path__ + "assets/img/index-banner3-2.e3430f77.png";